import auth0 from 'auth0-js';
import EventEmitter from 'eventemitter3';
import router from '../router';
import http from './http';
import DataHandlerService from './data';
import config from '../config'
import InMemoryDb from "../services/inmemorydb";
import RandomValues from "../utils/random";

import firebase from "firebase";

const dataHandler = new DataHandlerService();
const InMemoryDatabase = new InMemoryDb();
const randomValues = new RandomValues();

export default class AuthService {
    userProfile;
    authenticated = this.isAuthenticated();
    authNotifier = new EventEmitter();
    alertNotifier = new EventEmitter();
    
    auth0 = new auth0.WebAuth(config.auth0);

    validate(obj) {
      if (obj.code === 200 && obj.data !== null && obj.data !== {} && obj.data !== [] && obj.data.length !== 0
        && Object.keys(obj.data).length !== 0) {
        return true;
      }
      return false;
    }

    /* Auth0 methods begin */

    auth0login () {
        this.auth0.authorize();
    }

    handleAuth0() {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult, 'auth0');
            } else {
                router.replace('/');
            }
        })
    }

    loginFromAuth0(authResult) {
        const response = { token: '', user: {}, code: 200, message: ''}, header = {};
        let form = new FormData();
        form.append('username', authResult.idTokenPayload.sub);
        return new Promise((resolve, reject) => {
            http.post('user/read_by_username', form).then(body => {
                body = body['data']
                if (body['code'] === 200) {
                    form = new FormData();
                    form.append('phone', authResult.idTokenPayload.sub);
                    form.append('hash', config.defaultPassword);
                    form.append('remember', String(true));
                    http.post('profile/login', form).then(body => {
                        body = body['data'];
                        response['token'] = body['data']['token'];
                        header['user_session_token'] = response.token;
                        form = new FormData();
                        form.append('phone', authResult.idTokenPayload.sub);
                        http.post('profile/read_by_phone', form, { headers: header }).then(body => {
                            body = body['data'];
                            if (this.validate(body) === true) {
                                response['user'] = body['data'][0];
                                resolve(response);
                            } else {
                                response['code'] = 401;
                                response['message'] = 'Error logging in.'
                                reject(response);
                            }
                        }).catch((err) => reject(err));
                    }).catch((err) => reject(err));
                } else {
                    form = new FormData();
                    let email = '';
                    if (!authResult.idTokenPayload.email) {
                        email = authResult.idTokenPayload.email;
                    } else {
                        email = `${authResult.idTokenPayload.sub}@fauxinfodemics.com`;
                    }
                    form.append('phone', authResult.idTokenPayload.sub);
                    form.append('email', email);
                    form.append('name', authResult.idTokenPayload.name);
                    form.append('status', 'active');
                    form.append('hash', config.defaultPassword);
                    form.append('upload_id', '-');
                    http.post('profile/signup', form).then(body => {
                        body = body['data'];
                        if (body['code'] === 200) {
                            response['token'] = body['data']['token'];
                            header['user_session_token'] = response.token;
                            form = new FormData();
                            form.append('phone', authResult.idTokenPayload.sub);
                            http.post('profile/read_by_phone', form, { headers: header }).then(body => {
                                body = body['data'];
                                if (this.validate(body) === true) {
                                    response['user'] = body['data'][0];
                                    resolve(response);
                                } else {
                                    response['code'] = 401;
                                    response['message'] = 'Error logging in.'
                                    reject(response);
                                }
                            }).catch((err) => reject(err));
                        } else {
                            response['code'] = 401;
                            response['message'] = 'Error logging in.'
                            reject(response);
                        }
                    }).catch((err) => reject(err));
                }
            }).catch((err) => reject(err));
        });
    }
    
    signupDefault(input) {
        const response = { token: '', user: {}, code: 200, message: ''}, header = {};
        let form = new FormData();
        return new Promise((resolve, reject) => {
            form = new FormData();
            form.append('phone', input.phone);
            form.append('email', input.email);
            form.append('name', input.fullName);
            form.append('status', 'active');
            form.append('hash', input.hash);
            form.append('upload_id', '-');
            http.post('profile/signup', form).then(body => {
                body = body['data'];
                if (body['code'] === 200) {
                    response['token'] = body['data']['token'];
                    header['user_session_token'] = response.token;
                    form = new FormData();
                    form.append('phone', input.phone);
                    http.post('profile/read_by_phone', form, { headers: header }).then(body => {
                        body = body['data'];
                        if (this.validate(body) === true) {
                            response['user'] = body['data'][0];
                            resolve(response);
                        } else {
                            response['code'] = 401;
                            response['message'] = 'Authentication error.'
                            reject(response);
                        }
                    }).catch((err) => reject(err));
                } else {
                    response['code'] = 401;
                    response['message'] = 'Phone number or email already in use.'
                    reject(response);
                }
            }).catch((err) => reject(err));
        });
    }

    loginDefault(input) {
        const response = { token: '', user: {}, code: 200, message: ''}, header = {};
        let form = new FormData();
        return new Promise((resolve, reject) => {
            form = new FormData();
            form.append('phone', input.phone);
            form.append('hash', input.hash);
            form.append('remember', input.remember);
            http.post('profile/login', form).then(body => {
                body = body['data'];
                if (body.code === 200) {
                    response['token'] = body['data']['token'];
                    header['user_session_token'] = response.token;
                    form = new FormData();
                    form.append('phone', input.phone);
                    http.post('profile/read_by_phone', form, { headers: header }).then(body => {
                        body = body['data'];
                        if (this.validate(body) === true) {
                            response['user'] = body['data'][0];
                            resolve(response);
                        } else {
                            response['code'] = 401;
                            response['message'] = 'Error logging in.'
                            reject(response);
                        }
                    }).catch((err) => reject(err));
                } else {
                    response['code'] = 401;
                    response['message'] = 'Phone number or password incorrect.'
                    reject(response);
                }
            }).catch((err) => reject(err));
        });
    }

    saveInvite(_body) {
        return new Promise((resolve, reject) => {
            const form = new FormData();
            form.append('email', _body.value);
            http.post('invite/invite_by_email', form).then(body => {
                body = body['data'];
                if (body.code === 200) {
                    resolve();
                } else {
                    reject(body);
                }
            }).catch((err) => reject(err));
        });
    }

    renewSession () {
      this.auth0.checkSession({}, (err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
        } else if (err) {
          this.logout();
        }
      })
    }
    
    returnToken() {
        return this.tokens;
    }

    returnProfile() {
        return this.userProfile;
    }
    
    /* End of Auth0 methods */
    setSession(authResult, flag, redirect) {
        if (flag === 'auth0') {
            this.loginFromAuth0(authResult).then(response => {
                const [token, user] = [response['token'], response['user']];
                dataHandler.setUserSession(token);
                dataHandler.setUserData(user);
                this.authNotifier.emit('authChange', { authenticated: true });
                this.authNotifier.emit('loadCirclesAfterAuth', { profile_id: user._id });

                if (user.board_count) {
                    router.replace({ path: `/feed`});
                } else {
                    router.replace({ path: `/setup`});
                }
            }).catch(response => {
                this.alertNotifier.emit('error', { message: response.message });
                router.replace('/');
            });
        }
        if (flag === 'default') {
            const [token, user] = [authResult['token'], authResult['user']];
            dataHandler.setUserSession(token);
            dataHandler.setUserData(user);
            this.authNotifier.emit('authChange', { authenticated: true });
            this.authNotifier.emit('loadCirclesAfterAuth', { profile_id: user._id });

            if (redirect)  {
                if(router.currentRoute.path === `${redirect}`) {
                    router.go()
                } else {
                    router.replace({path: `${redirect}`})
                }
            } else {
                if (user.board_count) {
                    router.replace({ path: `/feed`});
                } else {
                    router.replace({ path: `/setup`});
                }
            }
        }
    }

    logout() {
      this.authNotifier.emit('authChange', { authenticated: false });
      window.localStorage.removeItem('ustk');
      window.localStorage.removeItem('udt');
      InMemoryDatabase.deleteData();
      router.replace('/');
    }

    isAuthenticated() {
        return (
            dataHandler.getUserData() &&
            dataHandler.getUserData() !== "" &&
            dataHandler.getUserSession() &&
            dataHandler.getUserSession() !== ""
        );
    }

    changeProfileImage(image) {
        return new Promise((resolve, reject) => {
            this.uploadImage(image).then((url) => {
                let form = new FormData();
                form.append("title", randomValues.secureRandString());
                form.append("path", url);
                form.append("tag", image.profile._id);
                http.post("upload/create", form).then(body => {
                    body = body["data"];

                    if (body["code"] === 200) {
                        const upload_id = body.data;
                        form = new FormData();

                        form.append("_id", image.profile._id);
                        form.append("phone", image.profile.phone);
                        form.append("name", image.profile.name);
                        form.append("email", image.profile.email);
                        form.append("upload_id", upload_id);
                        form.append("status", image.profile.status);
                        form.append("user_id", image.profile.user_id);
                
                        http.post("profile/update", form).then(body => {
                            body = body["data"];

                            if (body["code"] === 200) {
                                form = new FormData();
                                form.append("_id", upload_id);

                                http.post("upload/read", form).then(body => {
                                    body = body["data"];

                                    if (body["code"] === 200) {
                                        const upload = body.data[0];

                                        if (upload) {
                                            image.profile.upload = upload;
                                            image.profile.upload_id = upload_id;
                                        }
                                        resolve(image.profile);
                                    } else {
                                        reject(body);
                                    }
                                }).catch((err) => reject(err));
                            } else {
                                reject(body);
                            }
                        }).catch((err) => reject(err));
                    } else {
                        reject(body);
                    }
                }).catch(err => reject(err));
            }).catch(err => reject(err));
        });
    }

    uploadImage(image) {
        return new Promise((resolve) => {
        firebase.auth().signInWithEmailAndPassword(config.firebaseDefaultUser.email, config.firebaseDefaultUser.password)
            .then(async () => {
            const promise = new Promise((resolve, reject) => {
                const ref = firebase.storage().ref(`/uploads/user/${image.profile._id}/image/${randomValues.secureRandString()}`)
                .put(image.file);

                ref.on("state_changed", () => {}, () => reject(), () => {
                ref.snapshot.ref.getDownloadURL().then((url) => resolve(url));
                })
            });
            promise.then((url) => resolve(url)).catch(() => reject({ message: "An error occurred. Please try again."}))
            }).catch(() => reject({ message: "An error occurred. Please try again."}))
        });
    }

    editProfile(obj) {
        return new Promise((resolve, reject) => {
            const form = new FormData();

            form.append("_id", obj._id);
            form.append("phone", obj.phone);
            form.append("name", obj.name);
            form.append("email", obj.email);
            form.append("upload_id", obj.upload_id);
            form.append("status", obj.status);
            form.append("user_id", obj.user_id);

            http.post("profile/update", form).then(body => {
                body = body["data"];

                if (body["code"] === 200) {
                    resolve();
                } else {
                    reject(body);
                }
            }).catch((err) => reject(err));        
        });
    }

    changePassword(obj) {
        return new Promise((resolve, reject) => {
            const form = new FormData();

            form.append("username", obj.username);
            form.append("hash_old", obj.hash_old);
            form.append("hash_new", obj.hash_new);

            http.post("user/change_auth", form).then(body => {
                body = body["data"];

                if (body["code"] === 200) {
                    resolve();
                } else {
                    reject(body);
                }
            }).catch((err) => reject(err));        
        });
    }

    beginReset(phone) {
        return new Promise((resolve, reject) => {
            const form = new FormData();
            form.append('phone', phone);

            http.post('profile/reset_begin', form).then(body => {
                body = body.data;
                resolve(body)
            }).catch(err => reject(err));
        });
    }

    completeReset(token, hash) {
        return new Promise((resolve, reject) => {
            const form = new FormData();
            form.append('token', token);
            form.append('hash', hash);

            http.post('profile/reset_complete', form).then(body => {
                body = body.data;

                if (body.code === 200) {
                    resolve(body);
                } else {
                    body.message = `${body.message} Confirm that you entered the correct passcode sent to your phone number.`;
                    reject(body);
                }
            }).catch(err => reject(err));
        });
    }
}